import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '../services/projects.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  email: string = undefined;
  status: number = -1;

  constructor(private projectsService: ProjectsService) { }

  ngOnInit(): void {
  }

  sendMail() {
    console.log(this.email);
    if(this.email == undefined) {
      this.status = 1;
    } else {
      this.projectsService.subscribeMail(this.email).subscribe(res => {
        this.status = 0;
        this.email = undefined;
      });
    }
  }

}
